export type TUserNotificationPriority = 'normal' | 'urgent';
export interface IUserNotification {
  id: string;
  date: Date;
  subject: string;
  text: string;
  priority: TUserNotificationPriority;

}

export const emptyUserNotification: IUserNotification = {
  id: 'u-usr-ntf-0',
  date: null,
  subject: '',
  text: '',
  priority: "normal"
};

